import { useState }  from 'react'
import EditHintIcon  from './EditHintIcon'

// Texto do card que vira campo com duplo clique e salva ao clicar fora.
// Enter salva (exceto no multilinha) e Esc descarta a edição.
function InlineEditableText({ value, onSave, canEdit, multiline = false, placeholder = '', className = '' }) {

    const [ _isEditing, _setEditing ] = useState(false)
    const [ _draft,     _setDraft   ] = useState('')

    const _startEdit = () => {

        if (!canEdit) return

        _setDraft(value ?? '')
        _setEditing(true)
    }

    const _commit = () => {

        _setEditing(false)

        if (_draft.trim() !== (value ?? '').trim()) onSave(_draft.trim())
    }

    const _handleKeyDown = (event) => {

        if (event.key === 'Escape') _setEditing(false)
        if (event.key === 'Enter' && !multiline) event.currentTarget.blur()
    }

    if (!_isEditing && !canEdit) return <p className={className}>{value}</p>

    if (!_isEditing) {
        return (
            <div
                className="group flex items-start justify-between gap-1 px-1 -mx-1 rounded-[4px] cursor-text border border-dashed border-transparent hover:border-gray-300 hover:bg-[#f7f7f7] transition-colors"
                title="Clique duas vezes para editar"
                onDoubleClick={_startEdit}
            >
                <p className={`${className} flex-grow`}>
                    {value || <span className="italic font-normal text-gray-300 opacity-0 group-hover:opacity-100">{placeholder}</span>}
                </p>
                <EditHintIcon className="mt-[1px] !w-[13px] !h-[13px]" />
            </div>
        )
    }

    const inputProps = {
        autoFocus:  true,
        value:      _draft,
        onChange:   (event) => _setDraft(event.target.value),
        onBlur:     _commit,
        onKeyDown:  _handleKeyDown,
        className:  `${className} w-full border border-blue-500 rounded-[3px] px-1 focus:outline-none`
    }

    return multiline ? <textarea rows="3" {...inputProps} /> : <input type="text" {...inputProps} />
}

export default InlineEditableText
